import { PageHeaderMini } from 'components/eventView/layout/PageHeaderMini';
import { EVFormPageContent } from 'components/eventView/pages/EVFormPageContent';
import { StickyHeaderContentLayout } from 'elements/eventView/layout/StickyHeaderContentLayout';
import { StickyHeaderLayout } from 'elements/eventView/layout/StickyHeaderLayout';
import { motion } from 'framer-motion';
import { useContext } from 'react';
import { useParams } from 'react-router';
import { CtxEventView } from 'session/ctxEventView';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const EVFormPageMobile = (props: Props) => {
    const ctxEventView = useContext(CtxEventView);
    const { eventFormId } = useParams() as { eventFormId: string };

    const form = ctxEventView.forms.find((form) => form.eventFormId === eventFormId);

    if (!form) {
        return null;
    }

    return (
        <S_EVFormPageMobile className={props.className}>
            <StickyHeaderLayout>
                <PageHeaderMini>{form.title}</PageHeaderMini>
            </StickyHeaderLayout>
            <StickyHeaderContentLayout headerHeight={64}>
                <S_EVFormPageContent form={form} />
            </StickyHeaderContentLayout>
        </S_EVFormPageMobile>
    );
};

const S_EVFormPageMobile = styled(motion.div)`
    background-color: #ecf0f5;
    height: 100%;
`;

const S_EVFormPageContent = styled(EVFormPageContent)`
    padding: 15px 10px 200px 10px;
`;
